export default "__VITE_ASSET__DqaGMl2b__"